import arrow from "../../../../assets/gifs/arrow.gif";
import classes from "./PrimaryButtonAnimation.module.css";

const PrimaryButtonAnimation = () => {
  return (
    <div className={classes["primary-btn-animation"]}>
      <img
        src={arrow}
        alt="arrow"
        className={classes["primary-btn-animation__gif"]}
      />
    </div>
  );
};

export default PrimaryButtonAnimation;
